export default "__VITE_ASSET__eea782b4__"